// One dialog for every daily limit (any API call answering 402 opens it).
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { onLimit, type LimitError } from "../lib/api";
import { track } from "../lib/analytics";
import { useAuth } from "../lib/auth";
import { Modal } from "./ui";
import { Pashmak } from "./Pashmak";

const WHAT: Record<string, { name: string; free: string }> = {
  voice: { name: "voice call", free: "1 voice call a day" },
  chat: { name: "chat", free: "15 chat messages a day" },
  story: { name: "story", free: "3 stories a day" },
  pronounce: { name: "pronunciation check", free: "10 pronunciation checks a day" },
};

export function LimitDialog() {
  const [hit, setHit] = useState<LimitError | null>(null);
  const { tier, user } = useAuth();
  const nav = useNavigate();
  useEffect(
    () =>
      onLimit((e) => {
        setHit(e);
        track("limit_hit", { feature: e.feature });
        if (e.tier !== "pro") track("paywall_view", { source: `limit-${e.feature}` });
      }),
    []
  );
  if (!hit) return null;
  const w = WHAT[hit.feature] || { name: "feature", free: "today's free uses" };
  const close = (outcome: string) => {
    if (hit.tier !== "pro") track("paywall_close", { source: `limit-${hit.feature}`, outcome });
    setHit(null);
  };
  return (
    <Modal open onClose={() => close("dismiss")} label="Daily limit reached">
      <div className="stack" style={{ alignItems: "center", textAlign: "center" }}>
        <Pashmak mood="sleeping" size={120} />
        {tier === "pro" ? (
          <>
            <h2>That's a lot of practice today!</h2>
            <p className="sub">You've reached today's fair-use cap for {w.name}s. It resets at midnight UTC. Try a lesson or review your words meanwhile.</p>
            <button className="btn block" onClick={() => close("ok")}>OK</button>
          </>
        ) : (
          <>
            <h2>That's it for today's free {w.name}s</h2>
            <p className="sub">The free plan includes {w.free}. Pro unlocks unlimited practice: 30-minute calls, chat, stories and pronunciation checks.</p>
            <button
              className="btn gold lg block"
              onClick={() => {
                close("upgrade");
                nav("/pro");
              }}
            >
              {user?.trialUsed ? "See Pashmak Pro" : "Try Pro free for 7 days"}
            </button>
            <button className="btn ghost block" onClick={() => close("tomorrow")}>See you tomorrow</button>
            <p className="tiny muted">Lessons, the alphabet and reviewing your words are always free.</p>
          </>
        )}
      </div>
    </Modal>
  );
}
